import React from "react";
import { Box } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import LogoutIcon from "@mui/icons-material/Logout";
import { useSnackbarAlert } from "../../hooks/useSnackbarAlert";

const LogOutButton = ({ onClose }) => {
  const { handleLogout } = useAuth();
  const snackbar = useSnackbarAlert();

  const handleLogoutClick = () => {
    handleLogout();
    snackbar.info("You logged out successfully. See you soon!");
    if (onClose) onClose();
  };

  return (
    <Box
      onClick={handleLogoutClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.2,
        mx: 1.5,
        mt: 4,
        px: 2,
        py: 1,
        borderRadius: 2,
        backgroundColor: "#FFF3F1",
        color: "#FD7762",
        fontWeight: 600,
        cursor: "pointer",
        fontSize: "0.95rem",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "#FFE1DD",
          transform: "translateX(2px)",
        },
      }}>
      <LogoutIcon fontSize="small" />
      <span>Sign Out</span>
    </Box>
  );
};

export default LogOutButton;
